/**
 * Initial state
 */
const initialState = {
    submitting: false
};

/**
 * Sidebar reducer
 */
export default function (state = initialState, action) {
    const {type} = action;

    switch (type) {
        case 'IMPORT_RESET': {
            return initialState;
        }
        case 'IMPORT_UPLOAD_INPROGRESS': {
            return {
                ...state,
                submitting: true,
            }
        }
        case 'IMPORT_UPLOAD_SUCCESS': {
            return {
                ...state,
                submitting: false,
            }
        }
        case 'IMPORT_UPLOAD_FAILURE': {
            return {
                ...state,
                submitting: false,
            }
        }
        default:
            break;
    }

    return state
}


// WEBPACK FOOTER //
// ./src/reducers/fileImport.js